const progressStatus = {
  NONE: 'none',
  STARTED: 'started',
  DONE: 'done',
} as const

export type ProgressStatus = typeof progressStatus[keyof typeof progressStatus]

const baseAssistantOverviewUrl = 'https://assistant.getsilverfin.com/outliers?'

const filteredCategory = 'filtered'

const minimumSearchQueryLength = 3

export {
  filteredCategory,
  progressStatus,
  baseAssistantOverviewUrl,
  minimumSearchQueryLength,
}
